import { IEntesContratacion } from '../../app/models/entesContratacion.interface';

export const ENTES_CONTRATACION: IEntesContratacion[] = [
    {
        name: 'Todos',
        value: 'todos',
        label: 'Todos'
    },
    {
        name: 'Junta de Gobierno Local del Ayuntamiento de Jerez',
        value: 'ayto',
        label: 'Junta de Gobierno Local del Ayuntamiento de Jerez'
    },
    {
        name: 'COMUJESA',
        value: 'COMUJESA',
        label: 'Gerencia de Corporación Municipal de Jerez S.A. (COMUJESA)'
    },
    {
        name: 'EMUVIJESA',
        value: 'EMUVIJESA',
        label: 'Gerencia de la Empresa Municipal de la Vivienda de Jerez S.A.'
    },
    {
        name: 'CIRJESA',
        value: 'CIRJESA',
        label: 'Presidencia del Circuito de Jerez S.A.'
    },
    {
        name: 'FUNDARTE',
        value: 'FUNDARTE',
        label: 'Gerencia de la Fundación Cultural Universitaria de las Artes de Jerez. Fundación Pública Local (FUNDARTE)'
    },
    {
        name: 'Patronato de la Fundación Centro de Acogida San José',
        value: 'Patronato de la Fundación Centro de Acogida San José',
        label: 'Patronato de la Fundación Centro de Acogida San José'
    }
];